export default __webpack_public_path__ + "static/media/search-icon.dd754958.svg";